import React from "react";
import PropTypes from "prop-types";
import {Button, Card} from "antd";
import {XIcon} from "@web/assets/icons";
import {useDispatch} from "react-redux";
import aiActions from "@web/redux/ai/actions";
import useChatStream from "@web/hooks/useChatStream";
import now from "lodash/now";
import {LinesContext} from '@web/hooks/context';

ActiveWorkflowCard.propTypes = {
  path: PropTypes.string.isRequired,
  workflow: PropTypes.object.isRequired,
  collapsed: PropTypes.bool,
  onClickEdit: PropTypes.func,
  onClickClear: PropTypes.func,
  onAddContextPath: PropTypes.func,
  onRemoveContextPath: PropTypes.func,
};

function ActiveWorkflowCard(props) {
  const dispatch = useDispatch();
  const ctx = React.useContext(LinesContext);
  const [stream, sendRequest] = useChatStream(props.workflow?.agentId, true);
  const [chatStartTs, setChatStartTs] = React.useState(null);

  const onClearWorkflow = React.useCallback(() => {
    props.onClickClear ?
      props.onClickClear(props.path, props.workflow) :
    dispatch(aiActions.clearActiveApp(ctx.collectionId));
  }, [dispatch]);

  React.useEffect(() => {
    if (props.workflow && !stream?.length && !chatStartTs) {
      setChatStartTs(now());
      // console.log(">>>>>>>>>ActiveworkflowCard:sendRequest:workflow:", JSON.stringify(workflow, null, 2));
      // return sendRequest(
      //   "This workflow",
      //   {
      //     contextPaths: [props.path],
      //     history: 3,
      //     collectionPath: props.path + `/${props.agentId}`,
      //   });
    }
  }, [props.workflow, stream]);

  if (!props.workflow) {
    return null;
  }

  return <Card
    bordered={false}
    extra={
    <div className="space space-center-y">
      <Button ghost onClick={onClearWorkflow} className="icon-btn icon-right"><XIcon /></Button>
  </div>}
    className={`card-rounded card-no-separator card-simple relative extra-round${props.collapsed ? " card-h-200" : " card-h-400"} card-body-scroll`}
    title={props.workflow?.name}
  >
    <div className="space space-col">
      <span className="font-lg bolded">{props.workflow?.title}</span>
      <span className="ai-text font-lg">{props.workflow?.description}</span>
    </div>
  </Card>
}

export default ActiveWorkflowCard;
